import { useTranslation } from 'react-i18next'
import MTEMeasurementConfigure from '../../../../../Measurement/_components/MTE/MTEMeasurementConfigure'

interface Props {
    _ref: any
    tabledata: any
    literal: string
    onContinue: () => void
    onPrevious: () => void
}

const MteConfigureMeasurementDataModal: React.FC<Props> = ({ _ref, tabledata, literal, onContinue, onPrevious }) => {
    const { t } = useTranslation()
    return (
        <dialog ref={_ref} className="modal">
            <div className="modal-box w-11/12 max-w-5xl">
                <MTEMeasurementConfigure tabledata={tabledata} literal={literal} onContinue={onContinue} onPrevious={onPrevious} />
            </div>
            <form method="dialog" className="modal-backdrop">
                <button type="button">{t('close')}</button>
            </form>
        </dialog>
    )
}

export default MteConfigureMeasurementDataModal
